import {Component, Input} from '@angular/core';
import {TreeviewDirectory} from './treeview-directory';

@Component({
    selector: 'tree-view',
    templateUrl: './treeview.component.html',
    styleUrls: ['./treeview.component.css']
})

export class TreeviewComponent {
    @Input() directories: Array<TreeviewDirectory>;
    @Input() mode: string="icon";

    // Height in pixels of the body part for the image display
    public pictureBodyHeight : string = "120px";

    /**
     * Get the height of the body part for the image display, formatted as a string in pixels
     * If there is no background image, the picture body height will be the one found in css.
     * @param TreeviewDirectory dir : the local treeview directory 
     * @return string : the height in pixels for the body part for the image display
     */
    public getPictureBodyHeight(dir : TreeviewDirectory){
        if(dir.getBackground()){
            return this.pictureBodyHeight;
        }
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/treeview/treeview.component.ts